import './tripStops.css';
import mapData from "../../data/mapData";
import {useState} from "react";
const TripStops = ({activeStep, getSelectedTripStep = (step) => {}}) => {
    const [currentStep, setCurrentStep] = useState(activeStep);
    const getCurrentStep = (step) => {
        setCurrentStep(step);
        getSelectedTripStep(step);
    }

    return(
        <ul className={'trip-steps font-13 sf-medium grey-font'}>
            <li className={'from'}>
                <div className="place font-14 margin-b-3">Peenya, Bangalore</div>
                <div className="grey-font">14:32  |   12th Aug 2018</div>
            </li>
            {
                mapData.alertLoc.steps.map((step) =>
                    <li key={step.id} className={`step ${step?.id === activeStep?.id ? 'current' : ''}`}
                        onClick={event => getCurrentStep(step)}>
                        <div className="">{step.info.area}</div>
                        <div className={`${step.type}`}>{step.info.warning}</div>
                        <ul className="separator gap-15 grey-font">
                            <li>67km/h</li>
                            <li>14:46</li>
                            <li>12th Aug 2018</li>
                        </ul>
                    </li>
                )
            }

            <li className={'to'}>
                <div className="">Nungambakkam, Chennai</div>
                <ul className="separator grey-font gap-15">
                    <li>5:48</li>
                    <li>13th Aug 2018</li>
                </ul>
            </li>
        </ul>
    )
}

export default TripStops;
